<template>
    <div>
        <div class="bagrcos">
            <!-- 左侧树 -->
            <div style="width:300px;height: 80vh;overflow-y: scroll;">
                <a-tree v-if="data.length > 0" :tree-data="data" :defaultExpandAll="true"
                    @select="(a, b) => selectNode(a, b)" @rightClick="(a, b) => rightClick(a, b)"
                    :selectedKeys="selectedKeys">
                    <template #title="{ key: treeKey, title }">
                        <a-dropdown :trigger="['contextmenu']">
                            <span>{{ title }}</span>
                            <template #overlay>
                                <a-menu @click="({ key: menuKey }) => onContextMenuClick(treeKey, menuKey)">
                                    <a-menu-item key="1">新增</a-menu-item>
                                    <a-menu-item key="2">删除</a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>
                    </template>
                </a-tree>
            </div>
            <!-- 右侧表单 -->
            <div class="add_form">
                <div>
                    <h2 class="tip-icon"> {{ title }} </h2>
                </div>
                <br>
                <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="labelCol"
                    :wrapper-col="wrapperCol">

                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item label="菜单名称" prop="menuname">
                                <a-input placeholder="请输入菜单名称" v-model="formState.menuname" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="菜单排序" prop="menuorder">
                                <a-input type="number" placeholder="请输入菜单排序" v-model="formState.menuorder" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">

                            <a-form-model-item label="菜单状态" prop="menustatus">
                                <a-select show-search v-model="formState.menustatus" placeholder="请选择菜单状态">
                                    <a-select-option v-for="item in menuStateData" :key="item.value" :value="item.value">{{
                                        item.label }}</a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-model-item label="菜单图标" prop="menuicon">
                                <a-input placeholder="请输入菜单图标" v-model="formState.menuicon" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row class="footer">

                        <a-col :span="12">
                            <a-form-model-item label="菜单链接" prop="menulink">
                                <a-input placeholder="请输入菜单链接" v-model="formState.menulink" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="父级" prop="parentId">
                                <a-tree-select v-if="menuIddata.length > 0"
                                    :disabled="formState.parentid == '0' ? true : false" v-model="formState.parentid"
                                    style="width: 100%" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                    :tree-data="menuIddata" :treeNodeDisabledKey="'disabled'" placeholder="部门" allow-clear
                                    tree-default-expand-all>
                                </a-tree-select>
                                <template #title="{ value: val, label }">
                                    <b v-if="val != formState.parentid" style="color: #08c">sss</b>
                                    <template v-else>{{ label }}</template>
                                </template>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row class="remark">
                        <a-col :span="24">
                            <a-form-model-item label="备注" prop="remark">
                                <a-textarea v-model="formState.remark" style="height: 80px;" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
                <a-row style="margin-left: 10%;">
                    <a-col :span="24">
                        <a-button type="primary" @click="handleOk" class="btaction"><span>保存</span></a-button>
                    </a-col>
                </a-row>

            </div>
        </div>
    </div>
</template>

<script>
import { menuList, menuDelone, menuAdd, menuUpdate ,menuById} from "@/api/api.js"
import { DictionaryService } from "@common/services/dictionary.service";

export default {
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
            data: [],
            menuIddata: [],
            values: '',
            menuData: [],
            initData: [],//左键或右键选中结点的children
            title: '菜单编辑',
            updateId: "1",
            selectedKeys: ['1'], //默认选中节点
            columns: [
                {
                    title: '菜单名称',
                    dataIndex: 'title',
                    key: 'title',
                },
                {
                    title: '菜单链接',
                    dataIndex: 'mlink',
                    key: 'mlink',
                },
                {
                    title: '菜单图标',
                    dataIndex: 'menuIcon',
                    key: 'menuIcon',
                },
            ],
            title: '菜单编辑',
            formState: {
                menuname: "",
                menuorder: "",
                menustatus: undefined,
                parentid: "",
                menuicon: "",
                menulink: "",
                remark: "",
            },
            // 表单验证
            rules: {
                menuname: [
                    {
                        required: true,
                        message: "请输入菜单名称",
                        trigger: "change",
                    },
                    {
                        min: 1,
                        max: 100,
                        message: '长度1-100'
                    }
                ],
                menulink: [
                    {
                        min: 1,
                        max: 100,
                        message: '长度1-100'
                    }
                ],
                menuicon: [
                    {
                        min: 1,
                        max: 100,
                        message: '长度1-100'
                    }
                ],
                remark: [
                    {
                        min: 1,
                        max: 300,
                        message: '长度1-300'
                    }
                ],
                menuorder: [
                    {
                        required: true,
                        message: "请输入菜单排序",
                        trigger: "change",
                    },
                    {
                        min: 1,
                        max: 8,
                        message: '长度1-8'
                    }
                ],
                menustatus: [
                    {
                        required: true,
                        message: "请选择菜单状态",
                        trigger: "blur",
                    },
                ],
            },
            delid: "",
            menuStateData: []
        }
    },
    activated() {
        const myremark = document.querySelector('.remark').querySelector('.ant-form-item-label')
        const myrInput = document.querySelector('.remark').querySelector('.ant-form-item-control-wrapper')
        myremark.classList.add('ant-col-2');
        myremark.classList.remove('ant-col-5');
        myrInput.classList.add('ant-col-22');
        myrInput.classList.remove('ant-col-18');
        const myremark1 = document.querySelector('.remark').querySelector('.ant-col-2')
        myremark1.style.width = '10.333333%'
        const myrInput1 = document.querySelector('.remark').querySelector('.ant-col-22')
        myrInput1.style.width = '87.666667%'
        // 获取列表数据
        this.searchList()
        // 字典调用获取菜单状态
        DictionaryService.getAllNeedDic(["MENU_STATUS"]).then((res) => {
            this.menuStateData = DictionaryService.getOptions("MENU_STATUS");
            this.values = this.menuStateData
        });

    },
    mounted() {
       
    },
    methods: {
        // 菜单列表查询
        searchList() {
            let pageParam = {
                pageNum: 0,
                pageSize: 0,
                orderBy: '',
            };
            menuList({ pageParam: pageParam }).then((res) => {
                if (this.selectedKeys.includes('1')) {
                    res.content.forEach(item => {
                        if (item.id == '1') {
                            menuById({ id: item.id }).then((res) => {
                        this.formState.menuicon = res.content.menuIcon
                    this.formState.menulink = res.content.menuLink
                    this.formState.menuname = res.content.menuName
                    this.formState.menuorder = res.content.menuOrder
                    this.formState.menustatus = res.content.menuStatus
                    this.formState.parentid = res.content.parentId
                    this.formState.remark = res.content.remark
                    })
                        }
                    });
                }
                this.menuData = res.content
                this.getTreemenu(res.content, 0)
                this.getTree(res.content, 0)
            }).then((res)=>{
                this.traverse(this.menuIddata)
            })
        },
        // 树型下拉菜单列表获取
        getTree(data, parentId, updateId) {
            var streeMenu = [];
            for (var i = 0; i < data.length; i++) {
                var node = data[i];
                if (data[i].parentId == parentId) {
                    var newTree = {
                        key: node.id,
                        title: node.menuName,
                        value: node.id,
                        parentid: node.parentId,
                        children: this.getTree(data, node.id),
                    };
                    streeMenu.push(newTree);
                }
            }
            this.menuIddata = streeMenu;
            return streeMenu;
        },
        // 树型菜单列表获取
        getTreemenu(data, parentId) {
            var treeMenu = [];
            var streeMenu = [];
            for (var i = 0; i < data.length; i++) {
                var node = data[i]
                if (data[i].parentId == parentId) {
                    var newTree = {
                        key: node.id,
                        title: node.menuName,
                        mlink: node.menuLink,
                        children: this.getTreemenu(data, node.id)
                    };

                    treeMenu.push(newTree)

                }
            }
            this.data = treeMenu
            return treeMenu
        },
        //新增、编辑
        handleOk(e) {
            if (this.title === '菜单新增') {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        menuAdd({
                            "menuIcon": this.formState.menuicon,
                            "menuLink": this.formState.menulink,
                            "menuName": this.formState.menuname,
                            "menuOrder": this.formState.menuorder,
                            "menuStatus": this.formState.menustatus,
                            "parentId": this.formState.parentid,
                            "remark": this.formState.remark
                        })
                            .then(
                                (res) => {
                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        this.searchList()
                                        this.$refs["ruleForm"].resetFields();
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    }
                });
            } else {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        menuUpdate({
                            "id": this.updateId,
                            "menuIcon": this.formState.menuicon,
                            "menuLink": this.formState.menulink,
                            "menuName": this.formState.menuname,
                            "menuOrder": this.formState.menuorder,
                            "menuStatus": this.formState.menustatus,
                            "parentId": this.formState.parentid,
                            "remark": this.formState.remark
                        })
                            .then(
                                (res) => {
                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        this.searchList()
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    }
                });
            }

        },
        // 左侧列表树右击菜单事件
        onContextMenuClick(treeKey, menuKey) {
            this.selectedKeys.splice(0)
            this.selectedKeys.push(treeKey)
            let id = treeKey
            if (menuKey == '1') {
                this.title = '菜单新增'
                this.$refs["ruleForm"].resetFields();
                this.formState.parentid = treeKey
            } else if (menuKey == '2') {
                this.$confirm({
                    title: "确定是否删除?",
                    okText: "是",
                    cancelText: "否",
                    onOk: () => {
                        let obj = {
                            id: id
                        };
                        menuDelone(obj).then((res) => {
                            this.searchList();
                            this.selectedKeys.splice(0)
                            this.selectedKeys.push('1')
                        }, (err) => {
                        })
                    },
                    onCancel: () => { },
                });
            }
        },
        // 左键单机树节点
        selectNode(key, e) {
            let keys = [e.node.eventKey];
            this.title = "菜单编辑"
            this.updateId = keys[0]
            this.selectedKeys.splice(0)
            this.selectedKeys = keys
            this.getTree(this.menuData, 0)
            this.searchOne(keys)
            this.traverse(this.menuIddata)
        },
        // 右键单机树节点
        rightClick({ event, node }) {
            this.title = '菜单编辑'
            this.updateId = node._props.eventKey
            this.selectedKeys.splice(0)
            this.selectedKeys.push(node._props.eventKey)
            this.searchOne(node._props.eventKey)
            this.getTree(this.menuData, 0, node._props.eventKey)
            this.traverse(this.menuIddata)
        },
        // 禁用效果实现
        traverse(data) {
            for (let i = 0; i < data.length; i++) {
                var node = data[i]
                if (node.key == this.updateId) {
                    node.disabled = true
                    this.initData = node
                    this.againTraverse(this.initData.children)
                }
                this.traverse(data[i].children);
            }
            this.menuIddata=data
        },
        againTraverse(node) {
            for (let item of node) {
                item.disabled = true
                if (item.children && item.children.length) {
                    this.againTraverse(item.children)
                }
            }
            return node
        },
        //查询单个菜单
        searchOne(treeid) {
            this.menuData.forEach(item => {
                if (item.id == treeid) {
                    menuById({ id: item.id }).then((res) => {
                        this.formState.menuicon = res.content.menuIcon
                    this.formState.menulink = res.content.menuLink
                    this.formState.menuname = res.content.menuName
                    this.formState.menuorder = res.content.menuOrder
                    this.formState.menustatus = res.content.menuStatus
                    this.formState.parentid = res.content.parentId
                    this.formState.remark = res.content.remark
                    })
                 
                }

            });
        }
    },
}
</script>

<style scoped lang="less">
@import url('../../../../common/css/antd-table.less');

.appraisement-box {
    .header-edit {
        padding: 0 3%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .edit {
            display: flex;
        }
    }
}

.header {
    display: flex;
    justify-content: space-between;
}

.bagrcos {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    margin-top: 10px;
    // border: 1px solid blue;


    .add_form {
        flex: 1;

        h2 {
            font-size: medium;
        }

        margin-left: 100px;
    }
}
</style>
